<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Mail Adı</label>
            <input type="text" class="form-control" v-model="value.MailName" placeholder="Mail Adı" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Mail Adresi</label>
            <input type="text" class="form-control" v-model="value.MailAddress" placeholder="Mail Adresi" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Şifre</label>
            <input type="text" class="form-control" v-model="value.Password" placeholder="Şifre" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Host</label>
            <input type="text" class="form-control" v-model="value.Host" placeholder="Host" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Port</label>
            <input type="text" class="form-control" v-model="value.Port" placeholder="Port" />
        </div>
        <div class="col-12">
            <b-form-checkbox class="mb-50" id="EnableSSL" v-model="value.EnableSSL">SSL</b-form-checkbox>
        </div>
        
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
        
}
</script>

<style>

</style>